export enum ClientType {
  Proposer = '001',
  LifeAssured = '002',
  ProposerOrLifeAssured = '003',
  Nominee = '004',
  Assignee = '005',
  Trustee = '006',
  Payor = '007',
  CAC = '008',
  Beneficiary = '099',
}
